import { initColorSelect, doAjax, updateTableValue, initRedPointLogic } from './helper'
import { loadAlreadyCustomizedOptions, replaceImage } from './interior-general-logic'



const initSkySelectLogic = () => {
	initColorSelect()
	loadAlreadyCustomizedOptions();
	initRedPointLogic('sky', 'dot_sky', setImage)
	
}

function setImage(component, colorCode) {
	const carModel = document.querySelector("input[name=carmodel]").value;
	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value;
	const backSeatModel = document.querySelector("input[name=backseatmodel]").value;

	const imageSourceFront = aeo['images']['sky_' + frontSeatModel + '_front_view'][colorCode]		
	const imageSourceBack = aeo['images']['sky_' + backSeatModel + '_back_view'][colorCode]
	replaceImage(imageSourceFront, component + 'Color', 'car_frontseat')
	replaceImage(imageSourceBack, component, 'car_backseat')

	updateTableValue(component, colorCode, 'sky-components')
	doAjax({
		'interior_component': component,
		'color': colorCode,
		'src': imageSourceFront
	})
}

export { initSkySelectLogic };